<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import VueDropify from "vue-dropify";
import moment from "moment";

//Custom  Components
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";

export default {
  components: {
    DatePicker,
    VueDropify,
  },
  data() {
    return {
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      localEvent: {
        name: null,
        description: null,
        is_active: true,
        start_time_display: null,
        end_time_display: null,
        date_label: null,
        image: null,
        address: null,
        ticket_link: null,
        location_map_url: null,
      },
      imageToUpload: null,
      submitted: false,
      iBtnLoading: false,
      isSaveAndAddNew: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  validations: {
    localEvent: {
      name: {
        required,
      },
      description: {
        required,
      },
    },
  },
  mounted() {
    this.setIfEdit();
  },
  methods: {
    // Method is use for set data on edit
    setIfEdit() {
      if (this.currentProps.isEdit) {
        setTimeout(() => {
          this.localEvent.description =
            this.currentProps.selectedLocalEvent.description;
        }, 100);
        this.localEvent.name = this.currentProps.selectedLocalEvent.name;
        this.localEvent.start_time_display =
          this.currentProps.selectedLocalEvent.start_time_display;
        this.localEvent.end_time_display =
          this.currentProps.selectedLocalEvent.end_time_display;
        this.localEvent.date_label =
          this.currentProps.selectedLocalEvent.date_label;
        this.localEvent.address = this.currentProps.selectedLocalEvent.address;
        this.localEvent.ticket_link =
          this.currentProps.selectedLocalEvent.ticket_link;
        this.localEvent.location_map_url =
          this.currentProps.selectedLocalEvent.location_map_url;
        this.localEvent.image = this.currentProps.selectedLocalEvent.image;
      }
    },
    // Method is use for submit data
    onSubmit() {
      this.submitted = true;
      this.iBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.iBtnLoading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
        };
        this.localEvent.end_time = moment(this.localEvent.end_time).format("X");
        this.localEvent.start_time = moment(this.localEvent.start_time).format(
          "X"
        );
        data = { ...data, ...this.localEvent };
        if (typeof data.image == "string") {
          delete data.image;
        }
        const formData = new FormData();
        Object.keys(data).map((key) => {
          if (data[key] !== null) {
            formData.append(key, data[key]);
          }
        });
        if (this.imageToUpload !== null) {
          formData.append("image", this.imageToUpload);
        }
        if (this.currentProps.isEdit == false) {
          UserService.addLocalEvent(formData)
            .then((data) => {
              if (this.isSaveAndAddNew) {
                this.$emit("saveAndAddNew", data);
                this.data = {
                  name: "",
                  description: null,
                  is_active: true,
                  event_start_date: "",
                  end_time_display: "",
                  event_time: "",
                  image: "",
                  address: "",
                  ticket_link: "",
                  location_map_url: "",
                };
              } else {
                this.$emit("submitted", data);
              }
              this.iBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              this.iBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.updateLocalEvent(
            this.currentProps.selectedLocalEvent.id,
            formData
          )
            .then((data) => {
              this.$emit("submitted", data);
              this.iBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              this.iBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for save and add new local event continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new local event
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is use for maintained change image event
    changeImage(event) {
      this.imageToUpload = event[0] == undefined ? "" : event[0];
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{ this.currentProps.isEdit ? "Update" : "Add New" }} Local Event
        </h4>
        <hr />
      </div>

      <div class="col-md-6">
        <b-form-group class="mb-3" label="Name" label-for="name">
          <template slot="label">
            Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="localEvent"
            type="text"
            autocomplete="off"
            placeholder="Ex : localEvent Name"
            v-model="localEvent.name"
            :class="{
              'is-invalid': submitted && $v.localEvent.name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.localEvent.name.required">Name is required.</span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="event time" label-for="event_time">
          <b-form-input
            id="localEvent"
            type="text"
            autocomplete="off"
            placeholder="00:00 AM to 00:0 PM"
            v-model="localEvent.date_label"
            disabled
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="start On" label-for="start_on">
          <date-picker
            v-model="localEvent.start_time"
            id="start-date-input"
            format="YYYY-MM-DD"
            value-type="format"
            type="date"
            placeholder="YYYY-MM-DD"
          ></date-picker>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="end on" label-for="label_on">
          <date-picker
            v-model="localEvent.end_time"
            id="start-date-input"
            format="MM-YYYY-DD"
            value-type="format"
            type="date"
            placeholder="YYYY-MM-DD"
          ></date-picker>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="ticket link" label-for="ticket_link">
          <b-form-input
            id="localEvent"
            type="text"
            autocomplete="off"
            v-model="localEvent.ticket_link"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group
          class="mb-3"
          label="location_map_url"
          label-for="location_map_url"
        >
          <template slot="label">Map URL</template>
          <b-form-input
            id="localEvent"
            type="text"
            autocomplete="off"
            v-model="localEvent.location_map_url"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-12">
        <b-form-group class="mb-3" label="address" label-for="address">
          <template slot="label">Address</template>
          <b-form-input
            id="localEvent"
            type="text"
            autocomplete="off"
            v-model="localEvent.address"
          ></b-form-input>
        </b-form-group>
        <!-- description -->
        <div class="mb-3">
          <label for="description">
            <span slot="label"
              >Description <span class="text-danger">*</span></span
            >
          </label>

          <tinymce
            id="tinyMce-editor"
            v-model="localEvent.description"
            :plugins="plugins"
            :toolbar="toolbar"
            :other_options="options"
            :class="{
              'is-invalid': submitted && $v.localEvent.description.$error,
            }"
          ></tinymce>

          <div
            v-if="submitted && $v.localEvent.description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.localEvent.description.required"
              >Description is required.</span
            >
          </div>
        </div>

        <!-- upload img -->
        <VueDropify
          @upload="changeImage($event)"
          :src="localEvent.image ? localEvent.image : ''"
          message="Drop image here or click to select"
          id="image"
          class="mb-3"
        />
      </div>
      <div class="col-md-12">
        <b-button
          v-if="$route.path == '/local-event'"
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >
        <b-button
          v-if="this.currentProps.isEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="submit"
          @click="saveAndAddNew"
          :class="{
            disabled: isSaveAndAddNew === true && iBtnLoading,
          }"
        >
          <i
            v-if="isSaveAndAddNew === true && iBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >Save & Add</b-button
        >
        <b-button
          class="float-end"
          variant="outline-primary"
          type="submit"
          @click="onSubmit"
          :class="{
            disabled: isSaveAndAddNew === false && iBtnLoading,
          }"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="isSaveAndAddNew === false && iBtnLoading"
          ></i>
          {{ this.currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>
